// extracted by mini-css-extract-plugin
export default {"button":"d0tIVmxl2JwiGkLd3BJM"};